var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3039 15.2326C32.1607 15.3163 28.7508 17.0797 28.7508 20.9898C28.9115 25.4489 33.0539 27.0127 33.125 27.0127C33.0539 27.0963 32.4997 29.1431 30.8576 31.2884C29.5542 33.1366 28.1079 35 25.9115 35C23.8222 35 23.0722 33.7683 20.6615 33.7683C18.0725 33.7683 17.3399 35 15.3579 35C13.1615 35 11.6079 33.0369 10.2337 31.2061C8.44831 28.8099 6.93083 25.0496 6.87726 21.4391C6.84115 19.5258 7.23479 17.645 8.23401 16.0477C9.64437 13.8174 12.1621 12.3035 14.9118 12.2536C17.0186 12.1874 18.8936 13.6016 20.1792 13.6016C21.4115 13.6016 23.7151 12.2536 26.3214 12.2536C27.4464 12.2547 30.4464 12.5705 32.3039 15.2326ZM20.0011 11.8717C19.6261 10.1244 20.6615 8.37723 21.6258 7.26269C22.8579 5.91485 24.8039 5 26.4821 5C26.5893 6.74722 25.9104 8.46078 24.6969 9.7088C23.6079 11.0566 21.7329 12.0714 20.0011 11.8717Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformApple);
export default __webpack_public_path__ + "static/media/platform_apple.9ee813ec8237c40a83cc9eda72d5a177.svg";
export { ForwardRef as ReactComponent };